<style lang="scss" scoped src="./style.scss" />
<script lang="ts" src="./script.ts" />

<template>
    <div class="page">
        <main>
            <div class="container margin-top-56">
                <div class="row">
                    <div class="col-12 col-md-8 offset-md-2">
                        <div class="card">
                            <div class="card-header">
                                <Logo :logoUrl="data.clientLogoUrl" />
                            </div>
                            <div class="card-body">
                                <img class="align-items-start margin-bottom-28" src="@/assets/icon-success.svg" alt="Success" width="100" />
                                <h5 class="title">{{ getTranslation("OtpAlreadyCompletedTitle") }}</h5>
                                <p class="subtitle">{{ getTranslation("OtpAlreadyCompletedSubTitle") }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
